// libraries
import $ from 'jquery';
import cookie from 'cookie';

// shared
import {ready, loadAnalytics, ipInfo} from 'shared/utils';
import footerTemplate from 'shared/cookie-preference/footerTemplate.ejs';
import modalTemplate from 'shared/cookie-preference/modalTemplate.ejs';
import notificationTemplate from 'shared/cookie-preference/notificationTemplate.ejs';

const ACCEPT_ALL_PREFERENCE = {
  performance: true,
  advertising: true
};

let trackingPreference = null;
let currentPreferences = null;

/**
 * Detect bot browsers
 * @param {string} User Agent of the browser
 * @return {bool} Is the current user a bot or not
 */
export const isBot = (userAgent) => {
  return window._DATADOG_SYNTHETICS_BROWSER !== undefined // Datadog synthetics
    || /bot|google|baidu|bing|msn|duckduckbot|teoma|slurp|yandex/i.test(userAgent); // Crawler bots
};

try {
  currentPreferences = JSON.parse(cookie.parse(document.cookie).preference);
} catch (e) {}

export const shouldLoadAnalytics = () => {
  if (isBot(navigator.userAgent)) { // Prevent noise from bots in analytics
    return false;
  }

  if (currentPreferences && 'performance' in currentPreferences) {
    return !!currentPreferences.performance;
  } else {
    return !(window.AnalyticsData && window.AnalyticsData.region === 'eu'); // Turn off analytics for EU region
  }
};

trackingPreference = currentPreferences || ACCEPT_ALL_PREFERENCE;

shouldLoadAnalytics() && loadAnalytics(); // XXX: Refactor this, so it doesn't get executed upon parsing

export const showCookiePrefsFooter = () => {
  ready(() => {
    $('.cookie-preference-footer').removeClass('hidden');
  });
};

export const hideCookiePrefsFooter = () => {
  ready(() => {
    $('.cookie-preference-footer').addClass('hidden');
  });
};

ready(() => {
  let notificationTimeout;

  const renderModalState = () => {
    $('.js-change-cookie-preference[data-setting-name=advertising]').toggleClass('checked', trackingPreference.advertising);
    $('.js-change-cookie-preference[data-setting-name=performance]').toggleClass('checked', trackingPreference.performance);

    $('.js-change-cookie-preference.checked').prev('.outer-switch-label').text('Active').removeClass('inactive');
    $('.js-change-cookie-preference:not(.checked)').prev('.outer-switch-label').text('Inactive').addClass('inactive');
  };

  const renderNotification = () => {
    const $notification = $('.cookie-settings-notification');

    $notification.html(notificationTemplate());
    $notification.on('click', '.shared-notifications-dismiss-notification-button', function() {
      $(this).parents('.shared-toast').remove();
    });

    clearTimeout(notificationTimeout);
    notificationTimeout = setTimeout(() => {
      $('.cookie-settings-notification .shared-toast').remove();
    }, 3000);
  };

  const updatePreferences = (showNotification = true) => {
    renderModalState();
    trackingPreference.timestamp = Date.now();
    currentPreferences = trackingPreference;

    document.cookie = cookie.serialize('preference', JSON.stringify(trackingPreference));

    shouldLoadAnalytics() && loadAnalytics();

    if (showNotification) {
      renderNotification();
    }
  };

  const bindChangePreference = () => {
    $('.js-change-cookie-preference').on('click', function() {
      const setting = $(this).data('settingName');

      trackingPreference[setting] = !trackingPreference[setting];
      updatePreferences();
    });

    $('#cookie-settings').on('hidden.bs.modal', () => {
      const showNotification = !currentPreferences;

      updatePreferences(showNotification);
      $('.cookie-preference-footer').remove();
    });
  };

  const bindAcceptAll = () => {
    const $banner = $('.cookie-preference-footer');

    $banner.find('.cookie-preference-footer-accept').on('click', () => {
      $banner.remove();
      trackingPreference = ACCEPT_ALL_PREFERENCE;
      updatePreferences();
    });
  };

  const renderFooterTemplate = () => {
    $('body').append(footerTemplate());
    bindAcceptAll();
  };

  const renderModalTemplate = () => {
    $('body').append(modalTemplate());
    $('body').append('<div class="cookie-settings-notification shared-notifications"></div>');
    bindChangePreference();
    renderModalState();

    $('#cookie-settings').on('shown.bs.modal', () => {
      $('.cookie-preference-footer').remove();
      $('.js-dismiss-cookie-settings-modal').focus();
    });
  };

  const initializeGDPR = () => {
    const prefsSet = cookie.parse(document.cookie).preference;

    if (!prefsSet) {
      renderFooterTemplate();
      ipInfo().then(({inEU}) => {
        if (inEU) {
          showCookiePrefsFooter();
        }
      });
    }
  };

  renderModalTemplate();

  initializeGDPR();
});
